import { apiClient } from '@/services/apiClient';
import { useMutation } from '@tanstack/react-query';
import { Routes } from './routes';

export enum OptOutTrigger {
  LINK = 'link',
  GPC = 'gpc',
}

/** The BE always answers 200; `success: false` is the business-failure outcome. */
export interface OptOutResponse {
  success: boolean;
}

export const optOutMarketingEmail = (trigger: OptOutTrigger) =>
  apiClient.post<OptOutResponse>(Routes.MARKETING_EMAIL_OPT_OUT, { trigger });

export const useOptOutMarketingEmail = () => {
  return useMutation({
    mutationFn: optOutMarketingEmail,
  });
};
